import { render, staticRenderFns } from "./ViewPortNew.vue?vue&type=template&id=50fe0ede&"
import script from "./ViewPortNew.vue?vue&type=script&lang=js&"
export * from "./ViewPortNew.vue?vue&type=script&lang=js&"
import style0 from "./ViewPortNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports